import styled from "styled-components";

interface InputProps {
  type?: string;
  placeholder?: string;
  value?: string;
  marginBottom?: string;
  onfocus?: string;
  maxWidth?: string;
  minWidth?: string;
  onChange?(value: any): void;
  onFocus?(value: any): void;
}

export function Input({ type, placeholder, marginBottom, onfocus, minWidth, value, onChange, onFocus, maxWidth }: InputProps) {
  return (
    <Component
      type={type}
      placeholder={placeholder}
      marginBottom={marginBottom}
      value={value}
      onfocus={onfocus}
      onChange={(e) => onChange && onChange(e.target.value as any)}
      onFocus={(e) => onFocus && onFocus(e.target.value as any)}
      maxWidth={maxWidth}
      minWidth={minWidth}
    />
  )
}

const Component = styled.input<InputProps>`
  width: 100%;
  height: 65px;
  border-radius: 5px;
  background-color: ${({ theme }) => theme.colors.gray.light };
  border: ${({ theme }) => `2px solid ${theme.colors.gray.dark}` };
  font-size: 17px;
  padding: 0 16px;
  color: ${({ theme }) => theme.colors.gray.darker };
  margin-bottom: ${({ marginBottom }) => marginBottom || 0 };
  max-width: ${({ maxWidth }) => maxWidth || '100%' };
  min-width: ${({ minWidth }) => minWidth || '0' };

  &::-webkit-calendar-picker-indicator {
    display: none;
    -webkit-appearance: none;
  }

  @media screen and (max-width: ${({ theme }) => theme.device.mobile}) {
    height: 54px;
    font-size: 15px;
    max-width: 100%;
  }
`;